__turbopack_context__.v({
  "animate-learn-more-popover-in": "popover-module__wbkv0a__animate-learn-more-popover-in",
  "animate-learn-more-popover-out": "popover-module__wbkv0a__animate-learn-more-popover-out",
  "animate-popover-in": "popover-module__wbkv0a__animate-popover-in",
  "animate-popover-in-keyframes": "popover-module__wbkv0a__animate-popover-in-keyframes",
  "animate-popover-out": "popover-module__wbkv0a__animate-popover-out",
  "animate-popover-out-keyframes": "popover-module__wbkv0a__animate-popover-out-keyframes",
  "base-animation": "popover-module__wbkv0a__base-animation",
  "closing": "popover-module__wbkv0a__closing",
  "learn-more-animation": "popover-module__wbkv0a__learn-more-animation",
});
